<template>
  <v-app>
    <v-navigation-drawer :width="500" right persistent :mini-variant="miniVariant" :clipped="clipped" clipped-right v-model="drawerRight" app>
        <v-toolbar color="green lighten-1">
          <v-toolbar-title>Панель управления</v-toolbar-title>
           <!--<img src="./assets/location.png"/>-->
          <v-spacer></v-spacer>
        </v-toolbar>
        <!--<v-treeview hoverable multiple-active selectable :items="items" v-model="selectedItems">
        </v-treeview>
        -->
          <v-treeview :items="items" selectable v-model="selectedItems">
            <template
              slot="prepend"
              slot-scope="{item}"
            >
            <!--<span>{{item.id}}</span>-->
            </template>
            <template
              slot="append"
              slot-scope="{item}"
            >
            <v-select style="margin-right:5px;max-width: 70px;" v-model="yearsSelected[item.id]" :items="years" v-if="item.filter == 'year'" @input="mergeLayers(`${item.id}`)" />
            <v-select style="margin-right:5px;max-width: 220px;" v-model="prichnSelected" :items="pre_prichn" v-if="item.filter == 'pre_prichn'" @input="mergePrichn(`${item.id}`)" />
            </template>
          </v-treeview>
       <!-- <v-list class="pl-4">
          <v-checkbox v-bind:label="`Cities`" v-model="layerActive" secondary></v-checkbox>
        </v-list>
        -->
    </v-navigation-drawer>
    <v-navigation-drawer :width="400" left v-model="drawerLeft" app>
        <v-toolbar color="green lighten-1">
          <v-toolbar-title>К местоположению</v-toolbar-title>
           <!--<img src="./assets/location.png"/>-->
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container>
        <v-card>
    <v-card-title>
      <h4>Выбор лесного участка</h4>
    </v-card-title>
    <v-card-text>
    <v-form class="px3">
      <v-select
            :items="input.subjects"
            v-model="subject"
            label="Субъект РФ"
            required
        ></v-select>
        <v-select
            :items="input.forestries"
            v-model="forestry"
            label="Лесничество"
            required
        ></v-select>
        <v-select
            :items="input.local_forestries"
            v-model="local_forestry"
            label="Участковое лесничество"
            required
        ></v-select>
        <v-select
            :items="input.sub_forestries"
            v-model="sub_forestry"
            label="Урочище"
            required
        ></v-select>
        <v-combobox
              v-model="kv"
              :items="input.kvs"
              chips
              multiple
              label="Список кварталов"
          ></v-combobox>
    </v-form>
    </v-card-text>
  </v-card>
</v-container>
    </v-navigation-drawer>
    <v-toolbar color="green lighten-2" app>
      <v-toolbar-side-icon @click.native.stop="drawerLeft = !drawerLeft"></v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon @click.native.stop="drawerRight = !drawerRight"></v-toolbar-side-icon>
    </v-toolbar>
    <v-content>
      <v-container fluid ma-0 pa-0 fluid ma-0 pa-0 fill-height>
        <div id="map" style="height: 100%; width: 100%;z-index: 1;"></div>
      </v-container>
    </v-content>

     <v-bottom-nav app
      active.sync=1
      value="true"
      absolute
      color="green"
    >
      <v-btn flat color="teal">
        <span>1</span>
        <v-icon color="black">history</v-icon>
      </v-btn>

      <v-btn flat color="teal">
        <span>2</span>
        <v-icon>place</v-icon>
      </v-btn>

      <v-btn flat color="teal">
        <span>3</span>
        <v-icon>place</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-app>
</template>

<script>
var convert = require('xml-js')
import Image from "../assets/location.png";
import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
import HelloWorld from '../components/HelloWorld'
import L from 'leaflet'
import resizeEvent from 'element-resize-event'
export default {
  name: 'App',
  components: {
    HelloWorld
  },
  data () {
    return {
      wms_czl:'./wms',
      test: 0,
      mymap: false,
      addedLayers: {},
      miniVariant: false,
      clipped: false,
      drawerRight: false,
      drawerLeft: false,
      layerActive: false,
      title: 'ФБУ РОСЛЕСОЗАЩИТА',
      selectedItems: [3,6,8,39],
      pre_prichn: ['1 Лесные пожары','2 Насекомые','3 Почвенно-климатические','4 Болезни леса','5 Дикие животные','6 Антропогенные','7 Непатогенные', 'Все группы причин'],
      prichnSelected: '2 Насекомые',
      years: ['Все', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020','2021', '2022', '2023', '2024','2025','2026'],
      yearsSelected: {
        "14": "2019",
        "15": "2019",
        "22": "2019",
        "45": "2018",
        "46": "2018",
      },
      items: [
        {
          id: 1,
          name: 'ПОДЛОЖКА',
          children: [
            { id: 2, name: 'Sentinel' },
            //{ id: 3, name: 'ESRI Images', url: 'http://192.168.0.35:4000/mapproxy/service?', type: 'wms', idText: 'esri'},
            { id: 3, name: 'ESRI Images', url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', type: 'tile' },
            //{ id: 3, name: 'ESRI Images', url: 'https://tiles0.planet.com/basemaps/v1/planet-tiles/global_monthly_2018_08_mosaic/gmap/{z}/{x}/{y}.png?api_key=3dbb88b7cfc44065bdb5aef0550f0990' },
          ]
        },
        {
          id: 4,
          name: 'КАРТОГРАФИЯ',
          children: [
            //{ id: 5, name: 'Граница РФ' },
            //{ id: 6, name: 'Границы федеральных округов РФ', url: './wms', idText: 'russia_2010_fo', type: 'wms',zIndex: 4},
            { id: 6, name: 'Границы федеральных округов РФ', url: './tile&REQUEST=GetTile&LAYER=russia_2010_fo&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}', idText: 'russia_2010_fo', type: 'tile', zIndex: 4},
            { id: 7, name: 'Границы субъектов РФ', url: './wms', idText: 'russia_2010_fo_t', type: 'wms',zIndex: 4},
            { id: 8, name: 'Границы лесничеств РФ', url: './tile&REQUEST=GetTile&LAYER=russia_2010&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}', layers: 'russia_2010', idText: 'russia_2010', type: 'tile', zIndex: 3},
            //{ id: 7, name: 'Границы субъектов РФ' },
            { id: 9, name: 'Квартальная сеть', url: './wms', idText: 'kv_russia', type: 'wms'},
            { id: 10, name: 'Кадастровые границы ПКК', url: 'https://pkk5.rosreestr.ru/arcgis/services/Cadastre/CadastreWMS/MapServer/WMSServer', idText: '1,2,3,4,5,6,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,27,28,29,30,31,32,33', type: 'wms'},
            { id: 11, name: 'Границы ООПТ федерального значения', url: 'https://sooi.minprirody.ru/gis/geoserver41/wms', idText: 'oopt', type: 'wms'},
            //{ id: 12, name: 'Границы Арктической зоны' },
            { id: 49, name: 'Границы БПТ', url: './wms', idText: 'bpt', type: 'wms', zIndex: 5},
            { id: 39, name: 'Центры защиты леса', url: './wms', idText: 'czl_points', type: 'wms'},
          ]
        },
        {
          id: 13,
          name: 'Динамичные данные о состоянии лесов',
          children: [
            { id: 14, name: 'Пункты ППН', url: './wms', idText: 'ppn', filter: 'year', type: 'wms', zIndex: 5 },
            { id: 15, name: 'Пункты ЛПТ', url: './wms', idText: 'lpt', filter: 'year', type: 'wms', zIndex: 5 },
            { id: 16, name: 'Пункты учетов ВО(в разработке)' },
            { id: 17, name: 'Пункты детального надзора(в разработке)' },
            { id: 18, name: 'Данные экспедиции(в разработке)' },
            { id: 19, name: 'Резервации очагов вредных организмов(в разработке)' },
            { id: 20, name: 'Очаги вредных организмов(в разработке)' },
            { id: 21, name: 'Борьба с вредными организмами(в разработке)' },
            { id: 22, name: 'Результаты ДН ФБУ Рослесозащита', url: './tile&REQUEST=GetTile&LAYER=dlpm_all&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}', idText: 'dlpm_all', layers:'dlpm_all', filter: 'year', type: 'tile' },
            { id: 23, 
              name: 'Данные о пожарах ИСДМ',
              children: [
                { id: 24, name: 'ИСДМ 2014 год', url: './wms', idText: 'isdm_2014', type: 'wms' },
                { id: 25, name: 'ИСДМ 2015 год', url: './wms', idText: 'isdm_2015', type: 'wms' },
                { id: 26, name: 'ИСДМ 2016 год', url: './wms', idText: 'isdm_2016', type: 'wms' },
                { id: 27, name: 'ИСДМ 2017 год', url: './wms', idText: 'isdm_2017', type: 'wms' },
                { id: 28, name: 'ИСДМ 2018 год', url: './wms', idText: 'isdm_2018', type: 'wms' }
              ]
            },
            { id: 29, 
              name: 'ГМВЛ',
              children: [
                { id: 30, name: 'Питомники РФ', url: './wms', idText: 'pitom_2013', type: 'wms' },
                { id: 31, name: 'Лесные культуры РФ', url: './wms', idText: 'lk_2011', type: 'wms' }
              ]
            },
            { id: 32, 
              name: 'ЛПО',
              children: [
                { id: 33, name: 'Участки проведения ЛПО', url: './wms', idText: 'lpo_cards', type: 'wms' }
              ]
            },
            //{ id: 40, name: 'Насекомые-вредители в лесничествах', url: '/wms?map=/home/user/czl.map', idText: 'problem_forestries_2', type: 'wms' },
            { id: 42, name: 'Реестр УПП', url: './wms', idText: 'reestr_upp_s,reestr_upp_f', filter: 'pre_prichn', type: 'wms' },
            { id: 43, name: 'Тест Растр', url: './wms', idText: 'test_raster', type: 'wms' }
          ]
        },
        {
          id: 34, 
          name: 'Федеральный проект "Сохранение лесов"',
          children: [
            /*{ id: 35, name: 'Пилотные лесничества', 
              data: [
                { "type": "Feature", "properties": { "id": 1, "subject": "Московская область", "les_vo": "Ступинское", "x_min": 37.709301013731299, "y_min": 54.628766565525503, "x_max": 39.325934476294798, "y_max": 55.2815415069363 }, "geometry": { "type": "Point", "coordinates": [ 38.435570679863901, 55.008060567050762 ] } },
                { "type": "Feature", "properties": { "id": 2, "subject": "Хабаровский край", "les_vo": "Хабаровское", "x_min": 135.044522405685, "y_min": 48.168947627431301, "x_max": 136.23600687211999, "y_max": 48.914284399205897 }, "geometry": { "type": "Point", "coordinates": [ 135.668634019676972, 48.575417627703459 ] } },
                { "type": "Feature", "properties": { "id": 3, "subject": "Забайкальский край", "les_vo": "Агинское", "x_min": 113.773177999865, "y_min": 50.490645260902198, "x_max": 115.39382824948299, "y_max": 51.694015000292303 }, "geometry": { "type": "Point", "coordinates": [ 114.686686873301213, 51.040838412861042 ] } },
                { "type": "Feature", "properties": { "id": 4, "subject": "Республика Бурятия", "les_vo": "Курбинское", "x_min": 108.44736199985699, "y_min": 52.180348000360098, "x_max": 110.011079999842, "y_max": 52.967505000055802 }, "geometry": { "type": "Point", "coordinates": [ 109.270054536181547, 52.607526111314591 ] } },
                { "type": "Feature", "properties": { "id": 5, "subject": "Иркутская область", "les_vo": "Шелеховское", "x_min": 103.423849000231, "y_min": 51.809720999524799, "x_max": 104.214515999914, "y_max": 52.2652739992958 }, "geometry": { "type": "Point", "coordinates": [ 103.813205234603316, 52.003460972205509 ] } },
                { "type": "Feature", "properties": { "id": 6, "subject": "Томская область", "les_vo": "Тимирязевское", "x_min": 84.028135448499498, "y_min": 55.981316882337502, "x_max": 84.918070000030795, "y_max": 56.812628000382603 }, "geometry": { "type": "Point", "coordinates": [ 84.454244316026603, 56.361922407331136 ] } },
                { "type": "Feature", "properties": { "id": 7, "subject": "Республика Коми", "les_vo": "Сыктывкарское", "x_min": 50.258829671052702, "y_min": 61.289654940123597, "x_max": 51.382168084089898, "y_max": 61.99766358051 }, "geometry": { "type": "Point", "coordinates": [ 50.796811917069093, 61.645902429743998 ] } },
                { "type": "Feature", "properties": { "id": 14, "subject": "Красноярский край", "les_vo": "Большемуртинское", "x_min": 91.827469079999901, "y_min": 56.29086702, "x_max": 94.200042960000104, "y_max": 57.33787203 }, "geometry": { "type": "Point", "coordinates": [ 93.056886105246164, 56.91127724201182 ] } },
                { "type": "Feature", "properties": { "id": 13, "subject": "Нижегородская область", "les_vo": "Дальнеконстантиновское", "x_min": 43.621289311952502, "y_min": 55.613330411970303, "x_max": 44.4838872176216, "y_max": 56.1217868800613 }, "geometry": { "type": "Point", "coordinates": [ 44.067868333761659, 55.818471987111515 ] } },
                { "type": "Feature", "properties": { "id": 9, "subject": "Московская область", "les_vo": "Истринское", "x_min": 35.907587785447703, "y_min": 55.681412944452902, "x_max": 37.410725782957797, "y_max": 56.123703652802803 }, "geometry": { "type": "Point", "coordinates": [ 36.678287846112198, 55.89625246756998 ] } },
                { "type": "Feature", "properties": { "id": 10, "subject": "Московская область", "les_vo": "Наро-Фоминское", "x_min": 35.871466600903297, "y_min": 55.170870590362, "x_max": 37.150093900000499, "y_max": 55.5947146341205 }, "geometry": { "type": "Point", "coordinates": [ 36.45901334888719, 55.371442159759617 ] } },
                { "type": "Feature", "properties": { "id": 11, "subject": "Московская область", "les_vo": "Звенигородское", "x_min": 35.846586899861897, "y_min": 55.481406010179903, "x_max": 37.4156282175976, "y_max": 55.833256728816202 }, "geometry": { "type": "Point", "coordinates": [ 36.639529806610717, 55.678298827054853 ] } },
                { "type": "Feature", "properties": { "id": 12, "subject": "Московская область", "les_vo": "Подольское", "x_min": 37.053576135888697, "y_min": 54.995888127735299, "x_max": 38.118472844146403, "y_max": 55.720853071418802 }, "geometry": { "type": "Point", "coordinates": [ 37.643440665393292, 55.303885646061353 ] } },
                { "type": "Feature", "properties": { "id": 8, "subject": "Архангельская область", "les_vo": "Яренское", "x_min": 47.654881806250302, "y_min": 61.376354027690397, "x_max": 49.640795951884797, "y_max": 62.8517843267446 }, "geometry": { "type": "Point", "coordinates": [ 48.687766696790469, 62.080768509566134 ] } }
              ], 
              idText: 'markers', type: 'json'
            },*/
            { id: 36, name: 'Фонд лесовосстановления на 01.01.2019', url: './wms', idText: 'fond_01012019', type: 'wms' },
            { id: 37, name: 'Объекты работ 2019 года', url: './wms', idText: 'plan_2019', type: 'wms' },
            { id: 41, name: 'Объекты работ 2020 года', url: './wms', idText: 'plan_2020', type: 'wms' },
            { id: 51, name: 'Объекты работ 2021 года', url: './wms', idText: 'plan_2021', type: 'wms' },
            { id: 52, name: 'Объекты работ 2022 года', url: './wms', idText: 'plan_2022', type: 'wms' },
            //{ id: 38, name: 'Результаты работ за 2019 год', url: './wms', idText: 'gmvl_2019,gmvl_pilot,gmvl_moskov', type: 'wms'},
             { id: 38, name: 'Результаты работ за 2019 год', url: './tile&REQUEST=GetTile&LAYER=gmvl_2019&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}', layers: 'gmvl_2019,gmvl_pilot,gmvl_moskov', idText: 'gmvl_2019,gmvl_pilot,gmvl_moskov', type: 'tile'},
            //{ id: 47, name: 'Результаты работ за 2020 год', url: './wms', idText: 'gmvl_2020', type: 'wms'},
            { id: 47, name: 'Результаты работ за 2020 год', url: './tile&REQUEST=GetTile&LAYER=gmvl_2020&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}', layers: 'gmvl_2020', idText: 'gmvl_2020', type: 'tile'},
            //{ id: 48, name: 'Результаты работ за 2021 год', url: './wms', idText: 'gmvl_2021', type: 'wms'},
            { id: 48, name: 'Результаты работ за 2021 год', url: './tile&REQUEST=GetTile&LAYER=gmvl_2021&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}', layers: 'gmvl_2021', idText: 'gmvl_2021', type: 'tile'},
            //{ id: 50, name: 'Результаты работ за 2022 год', url: './wms', idText: 'gmvl_2022', type: 'wms'}
            { id: 50, name: 'Результаты работ за 2022 год', url: './tile&REQUEST=GetTile&LAYER=gmvl_2022&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}', layers: 'gmvl_2022', idText: 'gmvl_2022', type: 'tile'}
          ]
        },
         {
          id: 44, 
          name: 'Российская съемка НЦ ОМЗ',
          children: [
            { id: 45, name: 'Покрытие Канопус', url: './wms', idText: 'snimki_ncomz', type: 'wms', filter: 'year', sn_type: 1 },
            { id: 46, name: 'Покрытие Ресурс', url: './wms', idText: 'snimki_ncomz', type: 'wms', filter: 'year', sn_type: 2 },
          ]
        }
      ]
    }
  },
  mounted: function () {
    var selectedStyle = {
      "color": "#00ff00",
      fillColor: "#00ff00",
      fillOpacity: 0.05,
      "weight": 4,
      "opacity": 0.7
    }
    this.UpdateFilter()
    const options = {
      minZoom: 3,
      maxZoom: 15,
      worldCopyJump: '',
      crs: L.CRS.EPSG3857,
      center: [65, 105],
      zoom: 3,
      attributionControl: false,
      fadeAnimation: false,
      zoomAnimation: false
    }
    this.mymap = L.map('map', options)
    let _this = this
    this.selected = L.geoJson([],{style: selectedStyle}).addTo(this.mymap)
    this.mymap.on('click', _this.featureInfo)
    resizeEvent(document.getElementById('map'), function() {
      _this.mymap.invalidateSize()
    })
  },
  computed: {
    geom: function(){
      return this.$store.state.aside.bounds.geom
    },
    filter: function(){
      return this.$store.state.aside.filter.subject
    },
    input: function()
    {
      return this.$store.state.aside.input
    },
    changeFilter: function() {
      return [this.subject,this.forestry,this.local_forestry, this.sub_forestry,this.kv]
    },
    subject: {
      get () {
        return this.$store.state.aside.filter.subject
      },
      set (value) {
        this.$store.commit('setFilter', {type: 'subject', items: value})
        this.$store.commit('setFilter', {type: 'forestry', items: 0})
        this.$store.commit('setFilter', {type: 'local_forestry', items: 0})
        this.$store.commit('setFilter', {type: 'sub_forestry', items: 0})
        this.$store.commit('setFilter', {type: 'kv', items: []})
      }
    },
    forestry: {
      get () {
        return this.$store.state.aside.filter.forestry
      },
      set (value) {
        this.$store.commit('setFilter', {type: 'forestry', items: value})
        this.$store.commit('setFilter', {type: 'local_forestry', items: 0})
        this.$store.commit('setFilter', {type: 'sub_forestry', items: 0})
        this.$store.commit('setFilter', {type: 'kv', items: []})
      }
    },
    local_forestry: {
      get () {
        return this.$store.state.aside.filter.local_forestry
      },
      set (value) {
        this.$store.commit('setFilter', {type: 'local_forestry', items: value})
        this.$store.commit('setFilter', {type: 'sub_forestry', items: 0})
        this.$store.commit('setFilter', {type: 'kv', items: []})
      }
    },
    sub_forestry: {
      get () {
        return this.$store.state.aside.filter.sub_forestry
      },
      set (value) {
        this.$store.commit('setFilter', {type: 'sub_forestry', items: value})
        this.$store.commit('setFilter', {type: 'kv', items: []})
      }
    },
    kv: {
      get () {
        return this.$store.state.aside.filter.kv
      },
      set (value) {
        var vals = value.map(function(name) {
          if (typeof(name) === 'object') {
            return name.value
          }
          else {
            return name
          }
        })
        this.$store.commit('setFilter', {type: 'kv', items: vals})
      }
    }
  },
  methods: {
    updateGeom() {
      this.SelectedGeom = {
          "type": "Feature",
          "properties": {"party": "Democrat"},
          "geometry": this.geom
      }
      this.selected.clearLayers();
      this.selected.addData(this.SelectedGeom);
      this.mymap.fitBounds(this.selected.getBounds())
    },
    UpdateFilter(){
      this.$store.dispatch('UpdateFilter')
    },
    featureInfo: function(e) {
      var featureUrl = './wms'
      var tileUrl = ''
      let _this = this
      var latlng = e.latlng
      function getFeatureInfoUrl(map, layer, latlng, params) {
        var point = map.latLngToContainerPoint(latlng, map.getZoom()),
          size = map.getSize(),
          bounds = map.getBounds(),
          sw = bounds.getSouthWest(),
          ne = bounds.getNorthEast(),
          sw = L.Projection.SphericalMercator.project(sw)
          ne = L.Projection.SphericalMercator.project(ne)
        var defaultParams = {
          request: 'GetFeatureInfo',
          service: 'WMS',
          //srs: layer._crs.code,
          srs: 'EPSG:3857',
          styles: '',
          version: layer._wmsVersion,
          //format: layer.options.format,
          bbox: [sw.x,sw.y,ne.x,ne.y].join(','),
          height: size.y,
          width: size.x,
          layers: layer.options.layers,
          query_layers: layer.options.layers,
          info_format: 'text/html'
        }
        params = L.Util.extend(defaultParams, params || {})
        params[params.version === '1.3.0' ? 'i' : 'x'] = point.x
        params[params.version === '1.3.0' ? 'j' : 'y'] = point.y
        return featureUrl + '&' + L.Util.getParamString(params, layer._url, true).replace('?','')
      }
      //console.log(getFeatureInfoUrl(_this.mymap, this.addedLayers[50], e.latlng, {}))
      /*function getTileIJ(layer) {
        var crs = L.CRS.EPSG3857
        var tileSize = layer.options.tileSize
        var nwPoint = L.point(latlng.lng, latlng.lat).multiplyBy(tileSize);
        nwPoint.x+=1
        nwPoint.y-=1
        var sePoint = nwPoint.add(new L.point(tileSize, tileSize));
        var zoom = layer._tileZoom;
        var crs = L.CRS.EPSG3857
        var nw = crs.project(_this.mymap.unproject(nwPoint, zoom));
        var se = crs.project(_this.mymap.unproject(sePoint, zoom));
        var tilewidth = se.x-nw.x;
        var origin = layer._level.origin
        var fx = (nw.x - origin.x)/tilewidth
        var fy = (origin.y - nw.y )/tilewidth
        var col = Math.floor(fx)
        var row = Math.floor(fy)
        var i = Math.floor((fx-col)*tileSize)
        var j = Math.floor((fy-row)*tileSize)
      
       

        return [nw.x, nw.y, origin]
      }*/
      for (var layerId in this.addedLayers) {
        if (this.addedLayers[layerId].options.layers !== undefined) {
          var url = getFeatureInfoUrl(_this.mymap, this.addedLayers[layerId],
          e.latlng,
          {
              'info_format': 'application/vnd.ogc.gml',
              'radius': 100,
              'version': '1.1.1',
              //'layers': 'lpt,ppn,lk_2011',
             // 'query_layers': 'lpt,ppn,lk_2011'
              'year': this.yearsSelected[layerId]
          })
          switch (this.addedLayers[layerId].options.layers) {
            case 'lpt':
              Vue.http.get(url, {params: {}}).then((res) => {
                var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                var ID = result['lpt_layer']['lpt_feature'].id._text
                Vue.http.get('./php_scripts/cards/lpt/lpt.php?ID='+ID, {params: {}}).then((res) => {
                  //console.log(res)
                  var formpopup = L.popup({minWidth : 700, maxHeight: 500})
                    .setLatLng(latlng)
                    .setContent(res.body)
                    .openOn(_this.mymap)
                })
              })
              break;
            case 'ppn':
              Vue.http.get(url, {params: {}}).then((res) => {
                var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                var ID = result['ppn_layer']['ppn_feature'].id._text
                Vue.http.get('./php_scripts/cards/ppn/ppn.php?ID='+ID, {params: {}}).then((res) => {
                  //console.log(res)
                  var formpopup = L.popup({minWidth : 700, maxHeight: 500})
                    .setLatLng(latlng)
                    .setContent(res.body)
                    .openOn(_this.mymap)
                })
              })
              break;
            case 'lk_2011':
              Vue.http.get(url, {params: {}}).then((res) => {
                var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                var info = result['lk_2011_layer']['lk_2011_feature']
                console.log(info)
                var data = 'Субъект РФ: ' + String(info['Субъект_РФ']._text).replace('undefined', '') +
                  '<br>Лесничество: ' + String(info['Лесничеств']._text).replace('undefined', '') +
                  '<br>Участковое лесничество: ' + String(info['Участковое']._text).replace('undefined', '')+
                  '<br>Участок: ' + String(info['Участок']._text).replace('undefined', '')+
                  '<br>Квартал: ' + String(info['Квартал']._text).replace('undefined', '')+
                  '<br>Выдел: ' + String(info['Выдел']._text).replace('undefined', '')+
                  '<br>Имя: ' + String(info['Имя']._text).replace('undefined', '')+
                  '<br>Площадь: ' + String(info['Площадь']._text).replace('undefined', '')+
                  '<br>Порода: ' + String(info['Порода']._text).replace('undefined', '')+
                  '<br>Год создания: ' + String(info['Год_создан']._text).replace('undefined', '')+
                  '<br>Создатель: ' + String(info['Создатель']._text).replace('undefined', '')+
                  '<br>Схема: ' + String(info['Схема']._text).replace('undefined', '')+
                  '<br>Фотография: ' + String(info['Фото']._text).replace('undefined', '');
              
                var formpopup = L.popup()
                  .setLatLng(latlng)
                  .setContent(data)
                  .openOn(_this.mymap)
              })
              break;
            case 'lpo_cards':
              Vue.http.get(url, {params: {}}).then((res) => {
                var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                var info = result['lpo_cards_layer']['lpo_cards_feature']
                console.log(info)
                var id = String(info['id']._text).replace('undefined', '')
                var link = './php_scripts/getlpo.php?id='+id
                var data = 'Субъект: ' + String(info['subject']._text).replace('undefined', '') +
                  '<br>Лесничество: ' + String(info['les_vo']._text).replace('undefined', '') +
                  '<br>Участковое лесничество: ' + String(info['u_les_vo']._text).replace('undefined', '')+
                  '<br>Квартал: ' + String(info['kv']._text).replace('undefined', '')+
                  '<br>Выдел: ' + String(info['sknr']._text).replace('undefined', '')+
                  '<br>Вид мероприятия: ' + String(info['vid_mer']._text).replace('undefined', '')+
                  '<br>Площадь мероприятия: ' + String(info['s_mer']._text).replace('undefined', '')+
                  '<br>Главная порода: ' + String(info['poroda']._text).replace('undefined', '')+
                  '<br>Причина повреждения: ' + String(info['prich']._text).replace('undefined', '')+
                  '<br>Ведомость перечета: <a href="'+link+'">Загрузить</a>'
              
                var formpopup = L.popup()
                  .setLatLng(latlng)
                  .setContent(data)
                  .openOn(_this.mymap)
              })
              break;
            case 'gmvl_2019,gmvl_pilot,gmvl_moskov':
              Vue.http.get(url, {params: {}}).then((res) => {
                var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                try {
                  var info = result['gmvl_pilot_layer']['gmvl_pilot_feature']
                } catch (err) {
                  try {
                    var info = result['gmvl_moskov_layer']['gmvl_moskov_feature']
                  } catch (er1) {
                    
                  }
                  try {
                    var info = result['gmvl_2019_layer']['gmvl_2019_feature']
                  } catch (er1) {
                    
                  }
                }
                console.log(info)
                var id = String(info['id']._text).replace('undefined', '')
                var data = 'Субъект РФ: ' + String(info['sri']._text).replace('undefined', '') +
                  '<br>Лесничество: ' + String(info['mu']._text).replace('undefined', '') +
                  '<br>Участковое лесничество: ' + String(info['gir']._text).replace('undefined', '')+
                  '<br>Участок: ' + String(info['ugir']._text).replace('undefined', '')+
                  '<br>Квартал: ' + String(info['kv']._text).replace('undefined', '')+
                  '<br>Выдел: ' + String(info['sknr']._text).replace('undefined', '')+
                  '<br>Категория земель: ' + String(info['katzem']._text).replace('undefined', '')+
                  '<br>Площадь по данным ДЗЗ: ' + String(Number(info['area']._text).toFixed(1)+' Га').replace('undefined', '')+
                  '<br>Год образования: ' + String(info['god']._text).replace('undefined', '')+
                  '<br>Арендатор: ' + String(info['arenda']._text).replace('undefined', '')
              
                var formpopup = L.popup()
                  .setLatLng(latlng)
                  .setContent(data)
                  .openOn(_this.mymap)
              })
              break;
            case 'gmvl_2020':
              Vue.http.get(url, {params: {}}).then((res) => {
                var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                try {
                  var info = result['gmvl_2020_layer']['gmvl_2020_feature']
                } catch (err) {
                  
                }
                console.log(info)
                var id = String(info['id']._text).replace('undefined', '')
                var data = 'Субъект РФ: ' + String(info['sri']._text).replace('undefined', '') +
                  '<br>Лесничество: ' + String(info['mu']._text).replace('undefined', '') +
                  '<br>Участковое лесничество: ' + String(info['gir']._text).replace('undefined', '')+
                  '<br>Участок: ' + String(info['ugir']._text).replace('undefined', '')+
                  '<br>Квартал: ' + String(info['kv']._text).replace('undefined', '')+
                  '<br>Выдел: ' + String(info['sknr']._text).replace('undefined', '')+
                  '<br>Категория земель: ' + String(info['katzem']._text).replace('undefined', '')+
                  '<br>Площадь по данным ДЗЗ: ' + String(Number(info['area']._text).toFixed(1)+' Га').replace('undefined', '')+
                  '<br>Год образования: ' + String(info['god']._text).replace('undefined', '')+
                  '<br>Арендатор: ' + String(info['arenda']._text).replace('undefined', '')
              
                var formpopup = L.popup()
                  .setLatLng(latlng)
                  .setContent(data)
                  .openOn(_this.mymap)
              })
              break;
              case 'gmvl_2021':
                Vue.http.get(url, {params: {}}).then((res) => {
                  var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                  try {
                    var info = result['gmvl_2021_layer']['gmvl_2021_feature']
                  } catch (err) {
                    
                  }
                  console.log(info)
                  var id = String(info['id']._text).replace('undefined', '')
                  var data = 'Субъект РФ: ' + String(info['sri']._text).replace('undefined', '') +
                    '<br>Лесничество: ' + String(info['mu']._text).replace('undefined', '') +
                    '<br>Участковое лесничество: ' + String(info['gir']._text).replace('undefined', '')+
                    '<br>Участок: ' + String(info['ugir']._text).replace('undefined', '')+
                    '<br>Квартал: ' + String(info['kv']._text).replace('undefined', '')+
                    '<br>Выдел: ' + String(info['sknr']._text).replace('undefined', '')+
                    '<br>Категория земель: ' + String(info['katzem']._text).replace('undefined', '')+
                    '<br>Площадь по данным ДЗЗ: ' + String(Number(info['area']._text).toFixed(1)+' Га').replace('undefined', '')+
                    '<br>Год образования: ' + String(info['god']._text).replace('undefined', '')+
                    '<br>Арендатор: ' + String(info['arenda']._text).replace('undefined', '')
                
                  var formpopup = L.popup()
                    .setLatLng(latlng)
                    .setContent(data)
                    .openOn(_this.mymap)
                })
              break;
              case 'gmvl_2022':
                console.log('12345')
                Vue.http.get(url, {params: {}}).then((res) => {
                  var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                  try {
                    var info = result['gmvl_2022_layer']['gmvl_2022_feature']
                  } catch (err) {
                    
                  }
                  console.log(info)
                  var id = String(info['id']._text).replace('undefined', '')
                  var data = 'Субъект РФ: ' + String(info['sri']._text).replace('undefined', '') +
                    '<br>Лесничество: ' + String(info['mu']._text).replace('undefined', '') +
                    '<br>Участковое лесничество: ' + String(info['gir']._text).replace('undefined', '')+
                    '<br>Участок: ' + String(info['ugir']._text).replace('undefined', '')+
                    '<br>Квартал: ' + String(info['kv']._text).replace('undefined', '')+
                    '<br>Выдел: ' + String(info['sknr']._text).replace('undefined', '')+
                    '<br>Категория земель: ' + String(info['katzem']._text).replace('undefined', '')+
                    '<br>Площадь по данным ДЗЗ: ' + String(Number(info['area']._text).toFixed(1)+' Га').replace('undefined', '')+
                    '<br>Год образования: ' + String(info['god']._text).replace('undefined', '')+
                    '<br>Арендатор: ' + String(info['arenda']._text).replace('undefined', '')
                
                  var formpopup = L.popup()
                    .setLatLng(latlng)
                    .setContent(data)
                    .openOn(_this.mymap)
                })
              break;
              case 'dlpm':
                Vue.http.get(url, {params: {}}).then((res) => {
                  var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                  try {
                    var info = result['dlpm_layer']['dlpm_feature']
                  } catch (err) {
                    
                  }
                  console.log(info)
                  var data = '<br>Лесничество: ' + String(info['les_vo']._text).replace('undefined', '') +
                    '<br>Участковое лесничество: ' + String(info['uch_les_vo']._text).replace('undefined', '')+
                    '<br>Квартал: ' + String(info['kv']._text).replace('undefined', '')+
                    '<br>Выдел: ' + String(info['videl']._text).replace('undefined', '')+
                    '<br>Группа причин: ' + String(info['pre_prichn']._text).replace('undefined', '')
                
                  var formpopup = L.popup()
                    .setLatLng(latlng)
                    .setContent(data)
                    .openOn(_this.mymap)
                })
              break;
              case 'reestr_upp_s,reestr_upp_f':
                var pre_prichn
                if (this.prichnSelected === 'Все группы причин') {
                  pre_prichn = '1,2,3,4,5,6,7'
                } else {
                   pre_prichn = this.prichnSelected.split(" ")[0]
                }
                Vue.http.get(url, {params: {pre_prichn: pre_prichn}}).then((res) => {
                  var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                  try {
                    var info = result['reestr_upp_s_layer']['reestr_upp_s_feature']
                  } catch (err) {
                    try {
                      var info = result['reestr_upp_f_layer']['reestr_upp_f_feature']
                    } catch (er1) {
                      
                    }

                  }
                  var id = String(info['id5']._text).replace('undefined', '')
                  var proc = Number(String(info['proc']._text)).toFixed(2)
                  if (proc === 'NaN') {
                    proc = 0
                  }
                  var data = "Процент повреждений от лесной площади: " + proc + "%<br>"+
                  "<img src='./wms&SERVICE=WMS&VERSION=1.1.1&REQUEST=getlegendgraphic&FORMAT=image/png&LAYER=reestr_upp_s'>" 
                
                  var formpopup = L.popup()
                    .setLatLng(latlng)
                    .setContent(data)
                    .openOn(_this.mymap)
                })
              break;
              case 'snimki_ncomz':
              var sn_type = this.addedLayers[layerId].wmsParams.sn_type
              var sn_year = this.addedLayers[layerId].wmsParams.year
              Vue.http.get(url, {params: {radius: 20, sn_type: sn_type, year: sn_year, feature_count: 100}}).then((res) => {
                var result = JSON.parse(convert.xml2json(res.body, {compact: true, spaces: 4})).msGMLOutput
                var info = result['snimki_ncomz_layer']['snimki_ncomz_feature']
                var links = ''
                var distinctLincs=[]
                if(Array.isArray(info)) {
                  for(var item in info) {
                    distinctLincs.push(info[item].path1._text)
                  }
                  for(var jtem in this.unique(distinctLincs)) {
                    links += '<a href="'+'ftp:\\protect.akadem.ru\\'+this.unique(distinctLincs)[jtem].toLowerCase()+'">'+this.unique(distinctLincs)[jtem]+'</a><br>'
                  }
                } else {
                  links += '<a href="'+'ftp:\\protect.akadem.ru\\'+info.path1._text.toLowerCase()+'">'+info.path1._text+'</a><br>'
                }
                
              
                var formpopup = L.popup({minWidth: 500})
                  .setLatLng(latlng)
                  .setContent(links)
                  .openOn(_this.mymap)
              })
              break;
            default:
              // statements_def
              break;
          }
        }
      }
    },
    unique: function(arr) {
      let result = []
      for (let str of arr) {
        if (!result.includes(str)) {
          result.push(str)
        }
      }
      return result
    },
    mergeLayers: function(id) {
      if (this.addedLayers[id] !== undefined) {
        if (this.yearsSelected[id] === 'Все') {
          this.addedLayers[id].setParams({year: '2014,2015,2016,2017,2018,2019'})
        } else {
          this.addedLayers[id].setParams({year: this.yearsSelected[id]})
        }
      }
    },
    mergePrichn: function(id) {
      if (this.addedLayers[id] !== undefined) {
        if (this.prichnSelected === 'Все группы причин') {
          this.addedLayers[id].setParams({pre_prichn: '1,2,3,4,5,6,7'})
        } else {
          this.addedLayers[id].setParams({pre_prichn: this.prichnSelected.split(" ")[0]})
        }
      }
    },
    getAllItems: function(o, acc) {
      var i
      if (acc === undefined) {
        acc = {ids:[], layers:[]}
      }
      for (var k in o) {
        i = o[k];
        //console.log(i.name)
        if (i['children'] !== undefined) {
          this.getAllItems(i['children'], acc)
        }
        else {
          acc.ids.push(i.id)
          acc.layers.push(i)
        }
      }
      return acc
    }
  },
  watch: {
   'geom': 'updateGeom',
   'changeFilter': 'UpdateFilter',
    selectedItems: function (selected) {
      let _this = this
      var ids = this.getAllItems(_this.items).layers.map(item => item.id)
      //var activeId = selected.filter(item => _this.getAllItems(_this.items).layers[ids.indexOf(item)])
      //console.log(activeId)

      // delete unselected layers
      var removedIds = Object.keys(this.addedLayers).filter(item => !selected.includes(parseInt(item)))
      for (var i = 0; i < removedIds.length; i++) {
        _this.addedLayers[removedIds[i]].remove(_this.mymap)
        delete _this.addedLayers[removedIds[i]]
      }
      //
      //add selected layers
      var activatedLayers = this.getAllItems(_this.items).layers.filter(item => selected.indexOf(item.id) !== -1 && _this.addedLayers[item.id] === undefined)
      activatedLayers.forEach(layer => {
        switch (layer.type) {
          case 'tile':
            _this.addedLayers[layer.id] = L.tileLayer(layer.url, { maxZoom: 19, zIndex: layer.zIndex||2, layers: layer.layers, idText: layer.idText, type: layer.type })
            break
          case 'wms':
            if (layer.filter === 'year') {
              if (layer.sn_type !== undefined) {
                _this.addedLayers[layer.id] = L.tileLayer.wms(layer.url, {zIndex: layer.zIndex||2, tileSize: 2048, layers: layer.idText, transparent:true, format: 'image/png', sn_type: layer.sn_type, year: _this.yearsSelected[layer.id]})
              } else {
                _this.addedLayers[layer.id] = L.tileLayer.wms(layer.url, {zIndex: layer.zIndex||2, tileSize: 2048, layers: layer.idText, transparent:true, format: 'image/png', year: _this.yearsSelected[layer.id]})
              }
            } else if (layer.filter === 'pre_prichn') {
              _this.addedLayers[layer.id] = L.tileLayer.wms(layer.url, {zIndex: layer.zIndex||2, tileSize: 2048, layers: layer.idText, transparent:true, format: 'image/png', pre_prichn: this.prichnSelected.split(" ")[0]})
            } else {
              _this.addedLayers[layer.id] = L.tileLayer.wms(layer.url, {zIndex: layer.zIndex||2, tileSize: 2048, layers: layer.idText, transparent:true, format: 'image/png'})
            }
            break
          case 'json':
            function whenClicked(e, feature) {
              // e = event
              console.log(feature)
              // You can make your ajax call declaration here
              //$.ajax(... 
            }

            function onEachFeature(feature, layer) {
              //bind click
              layer.on({
                click: function(e) {
                  var xmin = feature.properties.x_min
                  var ymin = feature.properties.y_min
                  var xmax = feature.properties.x_max
                  var ymax = feature.properties.y_max
                  _this.mymap.invalidateSize()
                  _this.mymap.fitBounds([[ymin, xmin], [ymax, xmax]])
                  if (!_this.mymap.hasLayer(_this.addedLayers[38])) {
                    _this.selectedItems.push(38)  
                  }
                }
              })
            }
            function createCustomIcon (feature, latlng) {
              let myIcon = L.icon({
                iconUrl: './assets/sat.png',
                //shadowUrl: './assets/location.png',
                iconSize:     [35, 35], // width and height of the image in pixels
                //shadowSize:   [35, 20], // width, height of optional shadow image
                iconAnchor:   [12, 12], // point of the icon which will correspond to marker's location
                //shadowAnchor: [12, 6],  // anchor point of the shadow. should be offset
                popupAnchor:  [0, 0] // point from which the popup should open relative to the iconAnchor
              })
              return L.marker(latlng, { icon: myIcon })
            }
            var geojsonMarkerOptions = {
                radius: 8,
                fillColor: "#ff7800",
                color: "#000",
                weight: 1,
                opacity: 1,
                fillOpacity: 0.8
            }
            _this.addedLayers[layer.id] = L.geoJson(layer.data, { pointToLayer:
            function (feature, latlng) { return createCustomIcon (feature, latlng)}, 
              onEachFeature: onEachFeature
            })
            break
        }
        if (!_this.mymap.hasLayer(_this.addedLayers[layer.id])) {
          _this.addedLayers[layer.id].addTo(_this.mymap)
        }
      })
      //
    }
  }
}
</script>
<style>
@import "~leaflet/dist/leaflet.css";
.v-select {

}
</style>